import { render, staticRenderFns } from "./multiplechoice.vue?vue&type=template&id=c989cfd4&scoped=true"
import script from "./multiplechoice.vue?vue&type=script&lang=js"
export * from "./multiplechoice.vue?vue&type=script&lang=js"
import style0 from "./multiplechoice.vue?vue&type=style&index=0&id=c989cfd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c989cfd4",
  null
  
)

export default component.exports